import React from "react";

function OnlineShopFormContent(props) {
  return <div></div>;
}

export default OnlineShopFormContent;
